import React from 'react';
import { FadeIn } from '../animations/FadeIn';
import SafeIcon from '../../common/SafeIcon';

export const TrustStrip = () => {
  return (
    <section className="py-12 border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-6">
        <FadeIn>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 text-ink/70 text-sm font-medium">
            <div className="flex items-center gap-2">
              <SafeIcon name="Lock" className="text-mint text-lg" />
              <span>Private by design</span>
            </div>
            <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-gray-300"></div>
            <div className="flex items-center gap-2">
              <SafeIcon name="UserX" className="text-sky text-lg" />
              <span>No account required</span>
            </div>
            <div className="hidden md:block w-1.5 h-1.5 rounded-full bg-gray-300"></div>
            <div className="flex items-center gap-2">
              <SafeIcon name="Smartphone" className="text-mint text-lg" />
              <span>Your data stays on your device</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};